import { render } from "./QuestionFormBuilder.vue?vue&type=template&id=f1db2ee4&scoped=true"
import script from "./QuestionFormBuilder.vue?vue&type=script&lang=js"
export * from "./QuestionFormBuilder.vue?vue&type=script&lang=js"

import "./QuestionFormBuilder.vue?vue&type=style&index=0&id=f1db2ee4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1db2ee4"]])

export default __exports__